<template>
    <div>
        <FullPageLoader :isLoading="loading"/>

        <b-modal :active.sync="showRemoveProductModal" id="productremovemodal" aria-modal :width="600" :can-cancel="false">
            <div class="modal-card" style="width: auto">
                <b-loading :active.sync="loading" :is-full-page="false"></b-loading>

                <header class="modal-card-head"><p class="modal-card-title">Product verwijderen</p></header>

                <section class="modal-card-body" style="overflow: hidden;border-radius:0;">
                    <p>Weet je zeker dat je het product wil verwijderen?</p>
                </section>

                <footer class="modal-card-foot text-right">
                    <button class="button" type="button" @click="showRemoveProductModal = false">Annuleren</button>
                    <button class="button is-danger" @click="removeProduct">Verwijderen</button>
                </footer>
            </div>
        </b-modal>

        <div class="row">
            <div class="column medium-3 text-right float-right">
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button tag="router-link" :to="{ name: 'ProductsOverview' }" type="is-dark">Terug naar overzicht</b-button>
            </div>
            <div class="column medium-9">
                <h1>{{type == 'new' && !record.name ? 'Product toevoegen' : record.name }}</h1>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <div class="callout warning" v-if="record == null">
                    Product ophalen...
                </div>
                <div v-else>
                    <form class="form">
                        <b-tabs size="is-medium" class="block" v-model="tabIndex">
                            <b-tab-item label="Algemeen">
                                <!-- <div class="row" v-if="user && user.role == 'pit'">
                                    <div class="column">
                                        <b-field label="Organisatie (PIT)"
                                            :message="getError(errors, 'organisation')"
                                            :type="getType(errors, 'organisation', '')"
                                        >
                                            <span>
                                                <b-select placeholder="Selecteer een organisatie" v-model="record.organisation" expanded>
                                                    <option
                                                        v-for="organisation in organisations"
                                                        :value="organisation.id"
                                                        :key="'organisatie_'+organisation.id"
                                                    >(ID: {{ organisation.id }}) {{ organisation.name }}</option>
                                                </b-select>
                                            </span>
                                        </b-field>
                                        <br>
                                        <br>
                                    </div>
                                </div> -->

                                <b-field label="Naam"
                                    :message="getError(errors, 'name')"
                                    :type="getType(errors, 'name', '')"
                                >
                                    <b-input v-model="record.name"></b-input>
                                </b-field>

                                <b-field label="Voorraad product"
                                    :message="getError(errors, 'stock')"
                                    :type="getType(errors, 'stock', '')"
                                >
                                    <b-checkbox v-model="record.stock">Voor dit product moet de voorraad bijgehouden worden.</b-checkbox>
                                </b-field>


                                <slide-up-down :active="Boolean(record.stock)" :duration="500">
                                    <b-field label="Totaal aantal"
                                        :message="getError(errors, 'quantity')"
                                        :type="getType(errors, 'quantity', '')"
                                    >
                                        <b-input type="number" v-model="record.quantity"></b-input>
                                    </b-field>

                                    <b-field label="Aantal beschikbaar"
                                        :message="getError(errors, 'available')"
                                        :type="getType(errors, 'available', '')"
                                    >
                                        <b-input type="number" v-model="record.available"></b-input>
                                    </b-field>
                                </slide-up-down>

                                <hr>

                                <b-field :label="'Prijs ('+formatPrice+')'"
                                    :message="getError(errors, 'price')"
                                    :type="getType(errors, 'price', '')"
                                >
                                    <b-input v-model="record.price"></b-input>
                                </b-field>

                                <b-field :label="'Borg per stuk ('+formatDeposit+')'"
                                    :message="getError(errors, 'deposit')"
                                    :type="getType(errors, 'deposit', '')"
                                >
                                    <b-input v-model="record.deposit"></b-input>
                                </b-field>

                                <b-field label="BTW percentage"
                                    :message="getError(errors, 'btw')"
                                    :type="getType(errors, 'btw', '')"
                                >
                                    <b-input type="number" v-model.number="record.btw"></b-input>
                                </b-field>

                                <hr>
                                <h4>Contract</h4>
                                <b-field label="Standaard in contract"
                                    :message="getError(errors, 'contract_add')"
                                    :type="getType(errors, 'contract_add', '')"
                                >
                                    <b-checkbox v-model="record.contract_add" :true-value="1" :false-value="0">Product standaard toevoegen bij het aanmaken van een contract.</b-checkbox>
                                </b-field>

                                <b-field label="Eenmalig"
                                    :message="getError(errors, 'contract_once')"
                                    :type="getType(errors, 'contract_once', '')"
                                >
                                    <b-checkbox v-model="record.contract_once" :true-value="1" :false-value="0">
                                        Product toevoegen als 'eenmalig' wanneer het toegevoegd wordt aan een contract.
                                        <b-tooltip label="Alleen op de eerste factuur meenemen. Product verkopen, geen verhuur.">
                                            <b-icon size="is-small" icon="info-circle" />
                                        </b-tooltip>
                                    </b-checkbox>
                                </b-field>
                            </b-tab-item>

                            <b-tab-item label="Facturen" v-if="$route.params.id != 'nieuw'">
                                <div class="text-right">
                                    <b-button tag="router-link" :to="{ name: 'CreateInvoiceRecord', query: {product: record.id} }" type="is-primary" icon-left="euro-sign">Factuur maken</b-button>
                                </div>
                                <InvoicesTable
                                    type="product"
                                    :id="$route.params.id"
                                />
                            </b-tab-item>

                            <!-- <b-tab-item label="Logs" v-if="this.type == 'edit' && user && user.role == 'pit'">
                                <h3>Logs</h3>

                                <LogsRecord
                                    ref="LogsRecord"
                                    :getFilters="{0: {name: record.number, query: { subject_type: 'App\\Product', subject_id: record.id }}}"
                                />
                            </b-tab-item> -->
                        </b-tabs>
                    </form>
                </div>
            </div>
        </div>

        <slide-up-down :active="tabIndex == 0" :duration="500">
            <div class="row">
                <div class="column text-right">
                    <div class="formfooter">
                        <b-button type="is-danger" :loading="loading" v-if="type == 'edit'" @click="showRemoveProductModal = true">Verwijderen</b-button>
                        <b-button type="is-success" :loading="loading" @click="saveAndQuit">Opslaan en sluiten</b-button>
                    </div>
                </div>
            </div>
        </slide-up-down>
    </div>
</template>

<script>
// import Vue from 'vue'
// import LogsRecord from '../logs/LogsRecord'
import formvalidationMixin from '@/mixins/formvalidationMixin.js'
import toastMixins from '@/mixins/toastMixins.js'
import InvoicesTable from '@/vue/invoices/components/InvoicesTable'

export default {
    name: 'ProductsRecord',

    components: {
        // LogsRecord,
        InvoicesTable
    },

    mixins: [formvalidationMixin, toastMixins],

    data () {
        return {
            type: 'new',
            tabIndex: 0,
            loading: false,
            record: {},
            errors: {},
            showRemoveProductModal: false
        }
    },

    computed: {
        formatPrice(){
            return this.record.price && parseInt(this.record.price) > 0 ? '€ '+Number.parseFloat(this.record.price).toFixed(2) : '€ '+Number.parseFloat(0).toFixed(2)
        },
        formatDeposit(){
            return this.record.deposit && parseInt(this.record.deposit) > 0 ? '€ '+Number.parseFloat(this.record.deposit).toFixed(2) : '€ '+Number.parseFloat(0).toFixed(2)
        },
        user() {
            return this.$store.state.user
        },
        organisations() {
            return this.$store.state.organisations ? this.$store.state.organisations : null
        },
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        }
    },

    created () {
        if(this.$route.params.id == 'nieuw'){
            this.record.organisation = this.user.organisation
            this.record.btw = '21'
        } else if (this.$route.params.id){
            this.type = 'edit'
            this.fetchRecord()
        }
    },

    methods: {
        fetchRecord(){
            console.log('[🔥] Fetch product', this.$route.params)
            this.loading = true

            axios.get('/api/products/'+this.$route.params.id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                this.$set(this, 'record', response.data)
                this.$set(this.record, 'stock', Boolean(response.data.stock))
                // if(this.user.role == 'pit'){
                //     setTimeout(() => {
                //         this.$refs['LogsRecord'].load()
                //     }, 250)
                // }
            }).catch((error) => {
                console.error('[❌] Error while fetching product:', error)
            }).then(() => {
                this.loading = false
            })
        },

        save(){
            this.loading = true
            this.errors = {}

            return new Promise((resolve, reject) => {
                axios.post('/api/product/'+this.$route.params.id+'/save', this.record, {
                    headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
                }).then((response) => {
                    this.$set(this, 'record', response.data)

                    this.$buefy.toast.open({message: 'Succesvol opgeslagen!', type: 'is-success'})

                    resolve()
                }).catch((error) => {
                    if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                        this.showError('Opslaan niet mogelijk, enkel een administrator is gemachtigd om deze gegevens aan te passen.')
                    } else {
                        this.$buefy.toast.open({
                            message: 'Opslaan mislukt - Onvoldoende of onjuiste gegevens.',
                            type: 'is-danger'
                        })
                    }

                    console.error('[❌] Error while validating the product:', error)
                    this.errors = {...error.response.data.errors}
                    this.tabIndex = 0

                    this.loading = false

                    reject()
                }).then(() => {
                    this.loading = false
                })
            })
        },

        saveAndQuit(){
            this.save().then(() => {
                this.$router.push({name: 'ProductsOverview'})
            }).catch(() => {})
        },

        removeProduct(){
            this.loading = true

            axios.delete('/api/products/'+this.$route.params.id, {
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(response.data == 'success'){
                    this.showMessage('Product verwijderd!')
                    this.$router.push({name: 'ProductsOverview'})
                } else {
                    throw new Error()
                }
            }).catch((error) => {
                if(_.has(error, 'response.data.error') && error.response.data.error == 'not-org-admin'){
                    this.showError('Verwijderen niet mogelijk, enkel een administrator is gemachtigd om deze gegevens aan te passen.')
                } else {
                    this.showError('Daar gaat iets fout! Probeer het opnieuw')
                }

                setTimeout(() => {
                    this.loading = false
                    this.showRemoveProductModal = false
                }, 1000)
            }).then(() => {
                this.loading = true
            })
        }
    }
}
</script>